import Vue from 'vue'

const socket = new WebSocket(`wss://${process.env.WEBSOCKET_IP}:${process.env.WEBSOCKET_PORT}`)
const emitter = new Vue({
  data () {
    return {
      connectedToBarcodeScanner: false
    }
  },
  methods: {
    send (message) {
      if (socket.readyState === 1) {
        socket.send(message)
        return true
      } else {
        return false
      }
    },
    close () {
      socket.close()
    }
  }
})

socket.onmessage = function (msg) {
  emitter.$emit('message', msg.data)
}
socket.onerror = function (err) {
  emitter.$emit('error', err)
}

export default emitter



// WEBPACK FOOTER //
// ./src/barcode-scanner/socket.js